import axios from "axios";
import { message } from "ant-design-vue";
// import store from '@/store'
// import requestWhiteList from '@/common/constant'
// import indexOf from 'lodash/indexOf'
const statusOk = '200'
const success = 'success'
const loginStatus = '当前用户没有登录'
const TIMEOUT = 60000
const axiosCommon = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
    // get: {
    //   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    //   // 在开发中，一般还需要单点登录或者其他功能的通用请求头，可以一并配置进来
    // },
    // post: {
    //   'Content-Type': 'application/json;charset=utf-8'
    //   // 在开发中，一般还需要单点登录或者其他功能的通用请求头，可以一并配置进来
    // }
  },
  timeout: TIMEOUT,
  baseURL: process.env.NODE_ENV === 'production' ? process.env.BASE_URL : '/',
})

axiosCommon.interceptors.request.use((config) => {
  // if (indexOf(requestWhiteList, config.url) > -1) {
  //   config.cancelToken = new axios.CancelToken(function(cancel) {
  //     store.commit('user/pushToken', { cancelToken: cancel })
  //   })
  // }
  return config
}, (err) => {
  return Promise.reject(err)
})

axiosCommon.interceptors.response.use((response) => {
  if (response?.data === 'timeout') {
    window.location.href = '/login'
    return
  }
  if (
    response?.data?.status === statusOk &&
    response?.data?.msg === success &&
    response?.data?.id === ''
  ) {
    return response?.data?.data? response.data.data: response?.data?.data !== false;
  } else if (response?.data?.msg !== success) {
    if (response?.data?.msg === loginStatus) {
      // message.error(response?.data?.msg);
      window.location.href = '/login'
      // this.$router.push('/login')
    } else {
      message.error(response?.data?.msg)
      return {
        id: response?.data?.id,
        data: response?.data?.data,
        msg: response?.data?.msg
      }
    }
  } else {
    return null
  }
}, (err) => {
  if (axios.isCancel(err)) {
    console.log('Request canceled', err.message)
  } else {
    return Promise.reject(err)
  }
})

export default axiosCommon
